import { GetProductsPageDataResponseSchema, type GetProductsPageDataResponse } from '@vy/api-definition';
import { isEmptyString, withDefault } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomBaseUseQueryOptions } from '../requests-types/custom-use-query-options';
import { queryKeys } from '../../../services/query-key/query-keys';

type UseProductsPagePayload = Parameters<ReturnType<typeof getPrivateApi>['getProductsPageData']>[0];

export function useProductsPage(
  payload: UseProductsPagePayload = {},
  options?: CustomBaseUseQueryOptions<GetProductsPageDataResponse>,
) {
  return useQuery(
    queryKeys.productsPage(...Object.values(payload)),
    async () => {
      const api = getPrivateApi();
      const productsDataResponse = await api.getProductsPageData({
        search: isEmptyString(payload.search) ? undefined : payload.search,
        pageSize: withDefault(payload.pageSize, 100),
        page: withDefault(payload.page, 0),
      });

      return GetProductsPageDataResponseSchema.parse(productsDataResponse);
    },
    { ...options },
  );
}
